import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo_home.png'


const _hoisted_1 = { class: "opModal stepModal" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_3 = { class: "body" }
const _hoisted_4 = { class: "title-1 mt-4" }
const _hoisted_5 = { class: "title-3 mt-4" }
const _hoisted_6 = { class: "mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_localized_text, {
          class: "text-uppercase",
          localizedKey: "Attenzione",
          text: "Attenzione"
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Tornando indietro perderai le modifiche fatte alla tavola",
            text: "Tornando indietro perderai le modifiche fatte alla tavola"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          type: "button",
          class: "btn btn-white",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, [
          _createVNode(_component_localized_text, {
            class: "text-uppercase",
            localizedKey: "Annulla",
            text: "Annulla"
          })
        ]),
        _createElementVNode("div", {
          type: "button",
          class: "mt-2 btn btn-hollow",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.ok && _ctx.ok(...args)))
        }, [
          _createVNode(_component_localized_text, {
            class: "text-uppercase",
            localizedKey: "Continua",
            text: "Continua"
          })
        ])
      ])
    ])
  ]))
}